import {
    FETCH_FILTER_REBATE,
    LIST_FILTER_REBATE,
} from "./types";

const init = {
    isLoading: false,
    list: [],
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_FILTER_REBATE:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_FILTER_REBATE:
            return {
                ...state,
                isLoading: false,
                list: payload,
            };

        default:
            return state;
    }
}